export default {"src":"/_next/static/media/agenda.f1cec23f.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};